import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grow flex w-full text-sm"
}
const _hoisted_2 = { class: "relative bg-gray-100 p-1 rounded-xl flex w-full shadow-inner" }
const _hoisted_3 = ["aria-pressed", "disabled"]
const _hoisted_4 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center z-20 pointer-events-none"
}
const _hoisted_5 = ["aria-pressed", "disabled"]

import { computed } from "vue";
import InfoModal from "@/components/info/infoModal.vue";

const pageStr = "components.itemV2.itemV2StoneType"


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV2StoneType',
  props: ["stoneTypes"],
  emits: ['patch'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit
const bothActive = computed(() => isStoneTypeActive('earth') && isStoneTypeActive('lab'));

const activeIndex = computed(() => {
  if (bothActive.value) return -1;
  if (isStoneTypeActive('earth')) return 0;
  if (isStoneTypeActive('lab')) return 1;
  return -1;
});

const sliderStyle = computed(() => {
  if (activeIndex.value === -1) return { display: 'none' };

  const width = 50;
  const left = activeIndex.value * width;

  return {
    width: `calc(${width}% - 4px)`,
    left: `calc(${left}% + 2px)`,
  };
});

const isStoneTypeActive = (stoneType: string) => {
  for (const variantDataIdx in props.stoneTypes) {
    for (const variantDataValueIdx in props.stoneTypes[variantDataIdx].values) {
      if (
          props.stoneTypes[variantDataIdx].values[variantDataValueIdx].idx == stoneType &&
          props.stoneTypes[variantDataIdx].values[variantDataValueIdx].match == true
      ) {
        return true
      }
    }
  }
  return false
}

const hasStoneType = (stoneType: string) => (props.stoneTypes || []).some((variant: any) =>
    (variant.values || []).some((value: any) => value.idx === stoneType)
);

const setStoneType = (stoneType: string) => {
  const actionIdxs = []
  for (const variantDataIdx in props.stoneTypes) {
    for (const variantDataValueIdx in props.stoneTypes[variantDataIdx].values) {
      if (
          props.stoneTypes[variantDataIdx].values[variantDataValueIdx].idx == stoneType
      ) {
        actionIdxs.push(props.stoneTypes[variantDataIdx].idx)
      }
    }
  }

  if (!actionIdxs.length) return;

  emit('patch', {
    "action": actionIdxs,
    "value": stoneType,
    "certificated_diamond": 0
  })
}


return (_ctx: any,_cache: any) => {
  return (__props.stoneTypes && __props.stoneTypes.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "absolute top-1 bottom-1 bg-white rounded-lg shadow-sm transition-all duration-300 ease-out transform",
            style: _normalizeStyle(sliderStyle.value)
          }, null, 4),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["relative min-w-0 flex-1 flex cursor-pointer items-center justify-center gap-2 transition-colors duration-200 z-10 min-h-11 px-2 py-1.5 text-sm font-light rounded-lg disabled:opacity-40 disabled:cursor-not-allowed focus-visible:outline-gray-700", isStoneTypeActive('earth') ? 'bg-brand-main rounded-lg text-white' : 'text-gray-500 hover:text-gray-700']),
            "aria-pressed": isStoneTypeActive('earth'),
            disabled: !hasStoneType('earth'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setStoneType('earth')))
          }, _toDisplayString(_ctx.$t(pageStr + '.natural_diamond')), 11, _hoisted_3),
          (bothActive.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("div", { class: "bg-white rounded-full w-8 h-8 flex items-center justify-center shadow-md text-brand-main font-bold text-lg border-2 border-brand-main" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    "stroke-width": "1.5",
                    stroke: "currentColor",
                    class: "size-6"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244"
                    })
                  ])
                ], -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["relative min-w-0 flex-1 flex cursor-pointer items-center justify-center gap-2 transition-colors duration-200 z-10 min-h-11 px-2 py-1.5 text-sm font-light rounded-lg disabled:opacity-40 disabled:cursor-not-allowed focus-visible:outline-gray-700", isStoneTypeActive('lab') ? 'bg-brand-main rounded-lg text-white' : 'text-gray-500 hover:text-gray-700']),
            "aria-pressed": isStoneTypeActive('lab'),
            disabled: !hasStoneType('lab'),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setStoneType('lab')))
          }, _toDisplayString(_ctx.$t(pageStr + '.lab_diamond')), 11, _hoisted_5)
        ]),
        _createVNode(InfoModal, {
          id: "stoneType",
          value: isStoneTypeActive('earth') ? 'earth' : 'lab'
        }, null, 8, ["value"])
      ]))
    : _createCommentVNode("", true)
}
}

})